export default __webpack_public_path__ + "static/media/robot-right-direction.35472ec3.svg";